import * as React from 'react';

import { DataItemImportance } from '../../misc/api/apiTypes';
import Condition from '../../misc/components/Condition';
import { ConfigFieldValidation } from '../validation/ConfigurableItemValidator';
import { TextBox } from './TextBox';
import { useCurrentStudyConfigurationContext } from '../../Core/CurrentStudyConfigurationContext';
import { useFieldState, useFieldApi } from 'informed';
import { inputClasses } from '../validation/ValidationClasses';
import { ConfigurableDataItemIds } from '../../misc/api/ApiConfigurableDataItems';
import { useReferenceContextProvider } from '../../Core/ReferenceContextProvider';

interface ConfigFieldTextBoxProps {
    id: string;
    field: string;
    className: string;
    disabled?: boolean;
    hidden?: boolean;
    validated: boolean;
    required?: boolean;
    itemId: ConfigurableDataItemIds;
    isInputAddon?: boolean;
    inputAddon?: React.ReactNode;
    type?: string;
    autoComplete?: string;
    onBlur?: any;
}

export const ConfigFieldTextBox = (props: ConfigFieldTextBoxProps): JSX.Element => {
    const {
        id,
        field,
        className,
        disabled,
        hidden,
        validated,
        required,
        itemId,
        isInputAddon,
        inputAddon,
        type,
        autoComplete,
        onBlur
    } = props;

    const { dataItemConfigurationCollection } = useCurrentStudyConfigurationContext();
    const { unitTypes } = useReferenceContextProvider();

    const fieldApi = useFieldApi(field);

    if (dataItemConfigurationCollection === null || dataItemConfigurationCollection === undefined)
        throw 'Fields Configurations is not set';

    const item = dataItemConfigurationCollection.find(x => x.configurableDataItemId === itemId);

    return <>
        <Condition test={() => item.importanceId !== DataItemImportance.NotApplicable}>
            <div className={className} hidden={hidden} data-automationid={`${id}-form-group`}>
                <label htmlFor={id}>{item.displayText}</label>
                    <TextBox
                        id={id}
                        field={field}
                        className={inputClasses(fieldApi.getError())}
                        validate={ConfigFieldValidation(item, required, validated)}
                        disabled={disabled}
                        type={type}
                        autoComplete={autoComplete}
                        onBlur={onBlur}
                    inputAddon={isInputAddon && inputAddon === undefined ? unitTypes.find(ut => ut.id === item.unitTypeId)?.name : inputAddon}
            />
            </div>
        </Condition>
    </>
}
